import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

// Auth gate for the editor routes. When the user is NOT authenticated, redirect to
// the front page (which shows the login box) rather than rendering a token-less,
// broken editor.
//
// This previously gated on state.customer.data / state.customer.isLoading — fields
// that no longer exist, so the check silently passed for everyone (the gate did
// nothing). It now uses the real signal, auth.isAuthenticated (derived synchronously
// from the Auth0 token+profile in localStorage), which is why no "authenticating…"
// branch is needed.
const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
